import React from 'react';
import PropTypes from 'prop-types';

export const GridPanel = props => (
  <div className={`panel grid-panel ${props.titleForm ? 'expand-title' : ''}`}>
    <div className="panel-heading panel-title">{props.title}{props.titleForm}</div>
    <div className={`panel-body form-group form-inline grid-${props.headers.length}-columns`} >
      {props.headers}
      {props.bodies}
    </div>
    <div className="panel-footer" >
      {props.children}
    </div>
  </div>
);

GridPanel.propTypes = {
  title: PropTypes.string.isRequired,
  headers: PropTypes.arrayOf(PropTypes.element).isRequired,
  bodies: PropTypes.arrayOf(PropTypes.element).isRequired,
  children: PropTypes.arrayOf(PropTypes.element),
  titleForm: PropTypes.element,
};

GridPanel.defaultProps = {
  children: null,
  titleForm: null,
};
